import React, { Component } from "react";
import { AnimatedView } from "../../../components";
import {Checkbox, Alert, Tooltip } from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import Panel from "../../../components/panel/Panel";
import cx from "classnames";
import { createHashHistory } from "history";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { appConfig } from "../../../config";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import isEmpty from "lodash.isempty";

const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
    reader.readAsDataURL(file);
  });
};

let logoFile = "";
let siteResponse = "";
const history = createHashHistory();
let invaliddomain = "";
class StepOne extends Component {
  static propTypes = {
    siteDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
  };
  constructor(props) {
    super(props);
    this.state = {
      siteID: "",
      siteName: "",
      previousSiteName: "",
      siteNameExistError: "",
      siteDomain: "",
      previousSiteDomain: "",
      siteLogo: "",
      siteStatus: "Active",
      fileName: "",
      alertMessage: "",
      alert: false,
      siteDomainExistError: "",
      monthlyFee:"",
      commissionPercent:"",
      commissionGross:"",
      payVibeCommissionNet:"",
      perTransactionFee: "",
      invoiceDueDate:"",
      invoicingEmailAddress:[],
      minMonthlyFee:"",
      captchaKey:"",
      signed_nda_link:"",
      check_card: 0,
      dynamic_footer: 0,
      connectedOption: 0,
      commissionPercentRo:"",
      commissionGrossRo:"",
      payVibeCommissionNetRo:"",
      commissionType:"Gross",
      hideCaptcha: true,
      checked: false,
      application_fee:"",
      ischecked:"",

    };
    this.validate = this.validate.bind(this);
    this.handlesOnSiteNameChanged = this.handlesOnSiteNameChanged.bind(this);
    this.handleSiteDomainChanged = this.handleSiteDomainChanged.bind(this);
    this.handleSiteLogoChanged = this.handleSiteLogoChanged.bind(this);
    this.handleSiteStatusChanged = this.handleSiteStatusChanged.bind(this);
    this.handleCardDetal = this.handleCardDetal.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.previousStep = this.previousStep.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handlesOnChanged = this.handlesOnChanged.bind(this);
    this.handleDynamicFooter = this.handleDynamicFooter.bind(this);
    this.handleConnectedOption = this.handleConnectedOption.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    if (this.state.checked) {
        this.setState({
          ischecked: "false",
        })
    } else {
        this.setState({
          ischecked: "true",
        })
    }

    this.setState({
      checked: !this.state.checked,
      application_fee:this.state.application_fee
    })
  }

  handleDismiss() {
    this.setState({ alert: false });
  }

  handleShow() {
    this.setState({ alert: true });
  }
  validate = () => {
    let domain =
      "/[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}.[a-z]{2,4}\b(/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi";
    let isError = false;

    if (this.state.siteName.length === 0) {
      isError = true;
      this.setState({ siteNameError: "red" });
    } else if (this.state.siteName) {
      if (this.state.siteNameExistError !== "") {
        isError = true;
        this.setState({ siteNameError: "red" });
      }
    }

    if (this.state.siteDomain.length === 0) {
      isError = true;
      this.setState({ siteDomainError: "red" });
    } else if (this.state.siteDomain) {
      if (this.state.siteDomainExistError !== "") {
        isError = true;
        this.setState({ siteDomainError: "red" });
      }
    }
  // if(this.state.siteID === ''){
  //   if (this.state.siteLogo.length === 0 && this.state.siteID === "") {
  //     isError = true;
  //     this.setState({ siteLogoError: "red" });
  //   }


  //   let errors = [];
  //   const fileMinSize = 1 * 1000; // 1KB
  //   const fileMaxSize = 2 * 1000 * 1000; // 2MB

  //   if (!this.state.fileName) {
  //     isError = true;
  //     this.setState({
  //       siteLogoError: "red"
  //     });
  //   } else {
  //     this.setState({ siteLogoError: false });
  //   }
  //   if (this.state.fileName) {
  //     let file = this.state.fileName;

  //     let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

  //     if (!allowedExtensions.exec(file)) {
  //       isError = true;
  //       errors["file"] =
  //         "Please upload file having extensions .jpeg/.jpg/.png/.gif only.";
  //       this.setState({ errors: errors["file"] });
  //     } else if (file.size < fileMinSize) {
  //       isError = true;
  //       errors["file"] = "Scan file must be atleast 1kB";
  //       this.setState({ errors: errors["file"] });
  //     } else if (file.size > fileMaxSize) {
  //       isError = true;
  //       errors["file"] = "Scan file cannot exceed 2MB size";
  //       this.setState({ errors: errors["file"] });
  //     }
  //   } else {
  //     this.setState({ errors: [] });
  //   }
  // }
    return isError;
  };

  handlesOnChanged(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    if(e.target.name == 'commissionGross'){
      if(e.target.value !== '') {
        this.setState({
          payVibeCommissionNetRo: true,
          commissionPercentRo: true,
          commissionGrossRo: false,
          payVibeCommissionNet:'',
          commissionPercent:'',
          commissionType:'Gross'
        });
      } else {
        this.setState({
          commissionPercentRo: false,
          payVibeCommissionNetRo: this.state.connectedOption ==1 ? true : false,
          commissionGrossRo: false
        });
      }
    }else if(e.target.name == 'commissionPercent'){
      if(e.target.value !== '') {
        this.setState({
          payVibeCommissionNetRo: true,
          commissionGrossRo:true,
          commissionPercentRo: false,
          payVibeCommissionNet:'',
          commissionGross:'',
          commissionType:'Gross'
        });
      } else {
        this.setState({
          commissionPercentRo: false,
          commissionGrossRo: false,
          payVibeCommissionNetRo: this.state.connectedOption ==1 ? true : false,
        });
      }
    }else if(e.target.name == 'payVibeCommissionNet'){
      if(e.target.value !== '') {
        this.setState({
          commissionPercentRo: true,
          commissionGrossRo: true,
          payVibeCommissionNetRo: false,
          commissionPercent:'',
          commissionGross:'',
          commissionType:'Net'
        });
      } else {
        this.setState({
          payVibeCommissionNetRo: false,
          commissionGrossRo: false,
          commissionPercentRo: false
        });
      }      
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handlesOnSiteNameChanged(event) {
    if (`${event.target.name}Error` !== "") {
      this.setState({ [`${event.target.name}Error`]: "" });
    }
    if (this.state.siteNameExistError !== "") {
      this.setState({ siteNameExistError: "" });
    }
    this.setState({ siteName: event.target.value });
    if (event.target.value.length < 3) {
      this.setState({
        siteNameError: "Site name cannot be less then 3 characters!"
      });
    } else {
      this.setState({ siteNameError: "" });
    }
  }

  onSiteNameBlur = field => e => {
    e.preventDefault();
    if (this.state.previousSiteName !== field) {
      this.props.siteNameOnChange(field);
    }
  };

  onSiteDomainBlur = field => e => {
    e.preventDefault();
    if (field.length > 0) {
      if (this.state.previousSiteDomain !== field) {
        if (
          !/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gi.test(
            field
          ) &&
          !/^((https?:\/\/)|(www.))((\d+\.\d+.\d+.\d+)):\d{4}$/gi.test(field)
        ) {
          this.setState({ siteDomainExistError: "Invalid Format" });
        } else {
          this.props.siteDomainOnChange(field);
        }
      }
    }
  };

  handleSiteDomainChanged(event) {
    let isError = false;
    if (this.state.siteDomainError !== "") {
      this.setState({ siteDomainError: "" });
    }
    if (this.state.siteDomainExistError !== "") {
      this.setState({ siteDomainExistError: "" });
    }
    this.setState({ siteDomain: event.target.value });
  }

  handleSiteLogoChanged = e => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ errors: [] });
    let file = e.target.files[0];
    logoFile = file.name;
    getBase64(file).then(base64 => {
      localStorage.setItem("fileBase64", base64);
      this.setState({ siteLogo: localStorage.getItem("fileBase64") });
    });
    this.setState({ fileName: file.name });
  };

  handleSiteStatusChanged(event) {
    this.setState({ siteStatus: event.target.value });
  }

  handleCardDetal(event) {
    this.setState({ check_card: event.target.value });
  }

  handleDynamicFooter(event){
    this.setState({ dynamic_footer: event.target.value });
  }

  handleConnectedOption(event){
    this.setState({ connectedOption: event.target.value });
    if(event.target.value ==1){
      this.setState({ payVibeCommissionNetRo: true, payVibeCommissionNet:'', commissionGrossRo: false, commissionPercentRo: false,commissionPercent:'', commissionGross:''});
    }else{
      this.setState({ payVibeCommissionNetRo: false, commissionGrossRo: false, commissionPercentRo: false, commissionPercent:'', commissionGross:''});
    }
  }

  componentWillMount() {
    const rehydrate = JSON.parse(localStorage.getItem("addNewSiteSavedState"));
    this.setState(rehydrate);
  }

  componentWillUnmount() {
    localStorage.setItem("addNewSiteSavedState", JSON.stringify(this.state));
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.sitenameResponse !== nextProps.sitenameResponse &&
      !isEmpty(nextProps.sitenameResponse)
    ) {
      if (nextProps.sitenameResponse.response === "error") {
        this.setState({
          siteNameExistError: nextProps.sitenameResponse.message
        });
      }
    }

    if (
      this.props.sitedomainResponse !== nextProps.sitedomainResponse &&
      !isEmpty(nextProps.sitedomainResponse)
    ) {
      if (nextProps.sitedomainResponse.response === "error") {
        this.setState({
          siteDomainExistError: nextProps.sitedomainResponse.message
        });
      } else if (nextProps.sitedomainResponse.response === "success") {
        this.setState({ siteDomainExistError: "" });
      }
    }

    if (
      this.props.siteDetails !== nextProps.siteDetails &&
      !isEmpty(nextProps.siteDetails)
      ) {
      const siteDetails = nextProps.siteDetails;
      if(!isEmpty(siteDetails.commissionGross)){
        this.setState({ commissionGross: false,payVibeCommissionNetRo: true, commissionPercentRo: true });
      }else if (isEmpty(siteDetails.commissionGross) && !isEmpty(siteDetails.commissionPercent)){
        this.setState({ commissionGrossRo: true, payVibeCommissionNetRo: true, commissionPercentRo: false });
      }else if(isEmpty(siteDetails.commissionGross) && isEmpty(siteDetails.commissionPercent) && !isEmpty(siteDetails.payVibeCommissionNet)){
        this.setState({ commissionGrossRo: true, payVibeCommissionNetRo: false, commissionPercentRo: true });
      }
      if(!isEmpty(siteDetails)){
        this.setState({ hideCaptcha: false});
      }
     // alert(siteDetails.dynamic_footer);
      this.setState({
        siteID: siteDetails.siteID,
        siteName: siteDetails.siteName,
        previousSiteName: siteDetails.siteName,
        siteDomain: siteDetails.siteDomain,
        previousSiteDomain: siteDetails.siteDomain,
        fileName: siteDetails.siteLogo,
        siteStatus: siteDetails.status,
        commissionGross:siteDetails.commissionGross,
        commissionPercent:siteDetails.commissionPercent,
        payVibeCommissionNet:siteDetails.payVibeCommissionNet,
        commissionType:siteDetails.commissionType,
        signed_nda_link:siteDetails.signed_nda_link,
        monthlyFee:siteDetails.monthlyFee,
        minMonthlyFee:siteDetails.minMonthlyFee,
        invoicingEmailAddress: siteDetails.invoicingEmailAddress ? JSON.parse(siteDetails.invoicingEmailAddress).toString() : "",
        invoiceDueDate:siteDetails.invoiceDueDate,
        captchaKey:siteDetails.captchaKey,
        check_card:siteDetails.check_card,
        dynamic_footer:siteDetails.dynamic_footer,
        connectedOption:siteDetails.connectedOption,
        perTransactionFee:siteDetails.perTransactionFee,
        application_fee:siteDetails.application_fee,
        checked:siteDetails.checked,
        ischecked:siteDetails.ischecked,
      });
    }
  }

  previousStep = e => {
    e.preventDefault();
    const { history } = this.props;
    history.push("/viewSiteList");
  };

  nextStep(e) {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      let data;
      let sitelogoimg;
      let filename;
      let invoicemeail = !isEmpty(this.state.invoicingEmailAddress) ? this.state.invoicingEmailAddress.split(',') : "";
      // let invoicemeail = this.state.invoicingEmailAddress > 0 ? this.state.invoicingEmailAddress.split(',') : "";
      data = {
        siteID: this.state.siteID ? this.state.siteID : "",
        siteName: this.state.siteName.trim(),
        siteDomain: this.state.siteDomain.trim(),
        siteLogo: this.state.siteLogo,
        filename: this.state.fileName,
        siteStatus: this.state.siteStatus,
        commissionGross:this.state.commissionGross,
        commissionPercent: this.state.commissionPercent,
        commissionType: this.state.commissionType,
        payVibeCommissionNet: this.state.payVibeCommissionNet,
        signed_nda_link: this.state.signed_nda_link,
        monthlyFee:this.state.monthlyFee,
        invoiceDueDate:this.state.invoiceDueDate,
        invoicingEmailAddress:invoicemeail,
        minMonthlyFee:this.state.minMonthlyFee,
        captchaKey:this.state.captchaKey,
        check_card:this.state.check_card,
        dynamic_footer:this.state.dynamic_footer,
        connectedOption:this.state.connectedOption,
        perTransactionFee:this.state.perTransactionFee,
        application_fee:this.state.application_fee,
        checked:this.state.checked,
        ischecked:this.state.ischecked,
      };

      this.props.saveValues(data);
      this.props.nextStep();
    }
  }

  render() {
    let fileError = this.state.errors ? this.state.errors : [];
    let domainError = this.state.errors ? this.state.errors : [];
    const headerTitle = "Site Details";
    const previous = "Previous";
    const next = "Next";
    const hidden = (this.state.checked === "0" || this.state.checked === false) ? 'hidden' : '';

    let siteLogo = "";
    if (this.state.siteID && this.state.fileName) {
      siteLogo = (
        <img src={appConfig.site.siteurl + this.state.fileName} width="100px" />
      );
    }





    return (
      <div className="col-lg-12">
        <Panel hasTitle={true} title={headerTitle}>
          <div className="row">
            {this.state.alert &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
          </div>

          <form role="form" id="StepOne">
            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="siteName">Site Name</label>
                <div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Site Name"
                    name="siteName"
                    value={this.state.siteName}
                    onChange={this.handlesOnSiteNameChanged}
                    onBlur={this.onSiteNameBlur(this.state.siteName)}
                    style={{ borderColor: this.state.siteNameError }}
                    autoFocus
                  />
                </div>
                {this.state.siteNameExistError && (
                  <Tooltip
                    placement="bottom"
                    className="in"
                    id="tooltip-bottom"
                  >
                    {this.state.siteNameExistError}
                  </Tooltip>
                )}
              </div>

              {/*<div className="form-group">
                <label htmlFor="siteLogo">Site Logo</label>
                <div>
                  <input
                    type="file"
                    className="form-control"
                    name="siteLogo"
                    ref="upload"
                    accept="image/*"
                    onChange={this.handleSiteLogoChanged}
                    style={{ borderColor: this.state.siteLogoError }}
                  />
                </div>
                <p className="help-block">
                  Please choose .jpeg/.jpg/.png/.gif image only.
                  <input
                    type="text"
                    readOnly="true"
                    name="fileName"
                    value={this.state.fileName}
                  />
                </p>
                {fileError ? (
                  <span style={{ color: "red" }}>{fileError} </span>
                ) : (
                  []
                )}
              </div>
            */}
              <div className="form-group">
                <label htmlFor="ndaUrl">
                  Contracts URL
                </label>
                <div>
                  <input
                    type="text"
                    className="form-control"
                    name="signed_nda_link"
                    id="signed_nda_link"
                    placeholder="Contracts URL"
                    value={this.state.signed_nda_link || ""}
                    onChange={this.handlesOnChanged}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="siteDomain">
                  Site Domain <span style={{fontSize: '13px'}}>(format: http://domainname.com OR http://192.168.1.15:3001)</span>
                </label>
                <div>
                  <input
                    type="text"
                    className="form-control"
                    name="siteDomain"
                    id="siteDomain"
                    placeholder="Site Domain"
                    value={this.state.siteDomain}
                    onChange={this.handleSiteDomainChanged}
                    onBlur={this.onSiteDomainBlur(this.state.siteDomain)}
                    style={{ borderColor: this.state.siteDomainError }}
                  />
                </div>
                {this.state.siteDomainExistError && (
                  <Tooltip
                    placement="bottom"
                    className="in"
                    id="tooltip-bottom"
                  >
                    {this.state.siteDomainExistError}
                  </Tooltip>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="status">Site Status</label>
                <div>
                  <select
                    name="siteStatus"
                    className="form-control"
                    value={this.state.siteStatus}
                    onChange={this.handleSiteStatusChanged}
                  >
                    <option value="Active">Yes</option>
                    <option value="Inactive">No</option>
                  </select>
                  {this.state.statusError ? (
                    <span style={{ color: "red" }}>Select site status! </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="status">Footer Customization Option?</label>
                <div>
                  <select
                    name="siteStatus"
                    className="form-control"
                    value={this.state.dynamic_footer}
                    onChange={this.handleDynamicFooter}
                  >
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="status">Save Card Detail?</label>
                <div>
                  <select
                    name="check_card"
                    className="form-control"
                    value={this.state.check_card}
                    onChange={this.handleCardDetal}
                  >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="invoiceDueDate">
                  Invoice due date in days
                </label>
                <div>
                  <input
                    type="number"
                    className="form-control"
                    name="invoiceDueDate"
                    id="invoiceDueDate"
                    placeholder="Invoice Due Date (Eg:- 60)"
                    value={this.state.invoiceDueDate}
                    onChange={this.handlesOnChanged}
                  />
                </div>
              </div>
              <div className="form-group" style={{display: (this.state.hideCaptcha == true) ? 'none' : 'block' }}>
                <label htmlFor="captchaKey">
                  Update Google Captcha
                </label>
                <div>
                  <input
                    type="text"
                    className="form-control"
                    name="captchaKey"
                    id="captchaKey"
                    placeholder="Update Google Captcha"
                    value={this.state.captchaKey}
                    onChange={this.handlesOnChanged}
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="d-flex">
                  <Checkbox
                    name="checked"
                    defaultChecked={this.props.siteDetails.checked}
                    checked={ (this.state.checked === "0" || this.state.checked === false) ? false : true } 
                    onChange={ this.handleChange }
                    value={this.state.checked}
                  >Stripe Zero Merchant Remittance Fee</Checkbox>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="monthlyFee">PayVibe Monthly Fee Amount</label>
                <div>
                  <input
                      type="number"
                      className="form-control"
                      name="monthlyFee"
                      id="monthlyFee"
                      placeholder="Monthly Fee $"
                      value={this.state.monthlyFee || ""}
                      onChange={this.handlesOnChanged}
                      //style={{ borderColor: this.state.siteDomainError }}
                    />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="minMonthlyFee">PayVibe Minimum Monthly Fee Amount</label>
                <div>
                  <input
                      type="number"
                      className="form-control"
                      name="minMonthlyFee"
                      id="minMonthlyFee"
                      placeholder="Minimum Monthly Fee $"
                      value={this.state.minMonthlyFee || ""}
                      onChange={this.handlesOnChanged}
                    />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="status">Use Stripe Connected Account?</label>
                <div>
                  <select
                    name="connectedOption"
                    className="form-control"
                    value={this.state.connectedOption}
                    onChange={this.handleConnectedOption}
                  >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="commissionGross">
                  PayVibe Commission Of Gross
                </label>
                <div>
                  <input
                    type="number"
                    className="form-control"
                    name="commissionGross"
                    id="commissionGross"
                    placeholder="PayVibe Commission of Gross"
                    value={this.state.commissionGross}
                    onChange={this.handlesOnChanged}
                    readOnly = {this.state.commissionGrossRo}
                  />
                </div>               
              </div>
               <div className="form-group">
                <label htmlFor="commissionPercent">
                  PayVibe Commission % Of Adjusted Gross
                </label>
                <div>
                  <input
                    type="number"
                    className="form-control"
                    name="commissionPercent"
                    id="commissionPercent"
                    placeholder="PayVibe Commission % of Adjusted Gross"
                    value={this.state.commissionPercent}
                    onChange={this.handlesOnChanged}
                    readOnly = {this.state.commissionPercentRo}
                  />
                </div>               
              </div>
              <div className="form-group">
                <label htmlFor="commissionPercentNet">
                  PayVibe Commission % of Net
                </label>
                <div>
                  <input
                    type="number"
                    className="form-control"
                    name="payVibeCommissionNet"
                    id="payVibeCommissionNet"
                    placeholder="PayVibe Commission % of Net"
                    value={this.state.payVibeCommissionNet}
                    onChange={this.handlesOnChanged}
                    readOnly = {this.state.payVibeCommissionNetRo}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="perTransactionFee">
                  Per Transaction Fee (In Cents)
                </label>
                <div>
                  <input
                    type="number"
                    className="form-control"
                    name="perTransactionFee"
                    id="perTransactionFee"
                    placeholder="Per Transaction Fee In Cents"
                    value={this.state.perTransactionFee}
                    onChange={this.handlesOnChanged}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="invoicingEmailAddress">
                  Invoicing Email Address (comma separated)
                </label>
                <div>
                  <input
                    type="text"
                    className="form-control"
                    name="invoicingEmailAddress"
                    id="invoicingEmailAddress"
                    placeholder="Invoicing Email Address (eg@example.com,eg1@example.com)"
                    value={this.state.invoicingEmailAddress || ""}
                    onChange={this.handlesOnChanged}
                  />
                </div>
              </div>
              <div className={ hidden }>
                <div className="form-group">
                  <label htmlFor="application_fee">
                    Stripe Zero Merchant Remittance Fee (In %)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="application_fee"
                    id="application_fee"
                    placeholder="Stripe Zero Merchant Remittance Fee (%)"
                    value={this.state.application_fee || ""}
                    onChange={this.handlesOnChanged}
                  />
                </div>
              </div>
            </div>
            
            <div className="form-footer col-md-12">
              <Button
                bsStyle="success"
                className="btn -default pull-left"
                onClick={() => history.push(`/viewSiteList`)}
              >
                Back
              </Button>
              <Button
                bsStyle="info"
                className="btn -primary pull-right"
                onClick={this.nextStep}
              >
                Next
              </Button>
            </div>
          </form>
        </Panel>
      </div>
    );
  }
}

export default StepOne;



// WEBPACK FOOTER //
// ./src/app/views/manageSite/steps/StepOne.js